import React from "react";
import { get, isArray, isEmpty } from "lodash";
import { getVacationsMyList, postVacations } from "../../apis/vacation/vacations";
import { getApprobalListByParam } from "../../utils/approval";
import { dateToFormat, dateToViewFormatWithDayName, getDateRangeList, getDay, getFormatHour } from "../../utils/date";
import VacationDateItem from "../../components/Vacation/VacationDateItem";
import { DEFAULT_VACATION_LIST } from "../../constants/VACATION";

import { diffSeconds } from "../../utils/date";
import { isEqual } from "lodash";

const getTask = async ({ mode, defaultData, setForm }) => {

  const vacationsMyListData = [];

  await getVacationsMyList({
    "search": {
      "vacationType": "other",
      "isExpired": false
    },
    "offset": 0,
    "limit": 100
  })
    .then((res) => {
      // 사용개수가 남아있는 휴가 중 만료되지 않은 휴가현황 노출
      res.data.vacations.forEach((item) => {
        if (item.usableCount > 0 && diffSeconds(new Date(), item.expiredAt) >= 0) {
          vacationsMyListData.push(item);
        }
      });
    });

  const vacationsMyList = [
    ...DEFAULT_VACATION_LIST,
    ...vacationsMyListData.map(item => ({ label: item.title, value: item.vacationIdx }))
  ];
  const defaultVacation = get(vacationsMyList, '[0].value');

  const scheduleText = (schedule, dayRange) => {
    let vacationText = `${dateToViewFormatWithDayName(schedule.date)}${schedule.vacationDayType === 'half' ? ' 반차' : schedule.vacationDayType === 'quarter' ? '반반차' : ''}`;
    if (schedule.vacationDayType === 'half' || schedule.vacationDayType === 'quarter') {
      if (dayRange === 'full') {
        vacationText += ' ' + getFormatHour(schedule.startTime);
        vacationText += ' ~ ';
        vacationText += getFormatHour(schedule.endTime);
      } else {
        vacationText += ' ' + getFormatHour(schedule[dayRange]);
      }
    }
    return vacationText;
  };

  const getTitle = (form = { dates: [getDay(), getDay()] }) => {
    const vacation = vacationsMyList.find(f => f.value === (+form.vacationIdx || null)) || vacationsMyList[0];
    const title = `[${vacation.label}] ${dateToFormat(form.dates[0])} ~ ${dateToFormat(form.dates[form.dates?.length - 1])} 휴가요청`;
    return title;
  }
    ;
  const fields = [
    {
      title: "유형",
      key: "vacationIdx",
      type: "select",
      width: 400,
      options: {
        list: vacationsMyList
      },
      onChanged: ({ form, onChange }) => {

        if (mode !== "create") return;

        const title = getTitle(form);
        onChange({ target: { name: "title", value: title } });
      }
    },
    {
      title: "기간",
      key: "dates",
      type: "datepicker",
      detail: 'component',
      options: {
        mode: "range",
        dateFormat: "Y-m-d",
      },
      required: true,
      width: mode === 'create' ? 400 : '100%',
      onChanged: ({ form, onChange, ...props }) => {
        if (mode !== 'create') return;
        if (!isEmpty(form.dates)) {
          const dayRange = getDateRangeList(form.dates[0], form.dates[1]);
          const isSingle = dayRange.length === 1;
          const vacationSchedule = dayRange.map((d, idx) => {
            let loadSchedule = {};
            isArray(form?.vacationSchedule) &&
              (loadSchedule = form?.vacationSchedule.find(f => f.date === d));

            return {
              date: d,
              isSingle,
              isFirst: !isSingle && idx === 0,
              isLast: !isSingle && idx === dayRange.length - 1,
              // all 종일 half 반차 quarter 반반차
              vacationDayType: loadSchedule?.vacationDayType || "all",
              startTime: loadSchedule?.startTime ? dateToFormat(loadSchedule?.startTime, "HH:mm:ss") : "00:00:00",
              endTime: loadSchedule?.endTime ? dateToFormat(loadSchedule?.endTime, "HH:mm:ss") : "23:59:59",
              // startTime: "00:00:00", // "2021-05-01 09:00:00"
              // endTime: "23:59:50"
            };
          });

          const title = getTitle(form);
          if (!isEqual(form.vacationSchedule, vacationSchedule)) {
            setTimeout(() => {
              setForm({ ...form, title, vacationSchedule });
            });
          }
        }
      },
      component: ({ form }) => {
        const vacationSchedule = form.vacationSchedule;
        const isOneDay = vacationSchedule.length === 1;
        const startSchedule = vacationSchedule[0];
        const endSchedule = !isOneDay ? vacationSchedule[vacationSchedule.length - 1] : null;
        const holidays = vacationSchedule.filter(v => v.vacationDayType === "none");
        return <>
          <p>
            {scheduleText(startSchedule, isOneDay ? 'full' : 'startTime')} {endSchedule && `~ ${scheduleText(endSchedule, isOneDay ? 'full' : 'endTime')}`}
          </p>
          {
            !isEmpty(holidays) &&
            <p className='font-size-13'>(
              {holidays.map((h, idx) =>
                <React.Fragment key={idx}>
                  {idx > 0 && ', '}
                  {dateToViewFormatWithDayName(h.date)}
                  {holidays.length - 1 === idx && ' 휴무'}
                </React.Fragment>
              )}
              )</p>
          }
        </>;
      }
    },
    {
      title: ' ',
      isHide: ({ form }) => {

        return isEmpty(form.vacationSchedule) || mode !== 'create';
      },
      component: ({ form, onChange, setForm }) => {
        const _onChange = (schedule, idx) => {
          onChange({
            [`vacationSchedule[${idx}]`]: schedule
          });
        };
        return <>
          {form.vacationSchedule.map((schedule, idx) => (
            <VacationDateItem
              key={idx}
              schedule={schedule}
              onChange={(s) => _onChange(s, idx)}
            />
          ))}
        </>;
      }
    },
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "사유",
      key: "description",
      type: "textarea",
      required: true,
    },
    {
      title: "첨부파일",
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    ...mode !== 'create' ? {} : {},
    vacationIdx: mode === "create"
      ? get(defaultData, 'data.vacationRequest.vacationIdx', defaultVacation) + ""
      : get(defaultData, 'data.vacation.vacationTitle', defaultVacation),
    dates: [
      get(defaultData, 'data.vacationRequest.startDate', getDay()),
      get(defaultData, 'data.vacationRequest.endDate', getDay()),
    ],
    vacationSchedule: get(defaultData, 'data.vacationRequest.vacationSchedule', []),
    title: get(defaultData, 'data.vacationRequest.title', getTitle()),
    description: get(defaultData, 'data.vacationRequest.description', ""),
    uploadFiles: get(defaultData, 'data.vacationRequest.uploadFiles', []),
  };

  const getParams = (form) => {
    return {
      vacationIdx: Number(form.vacationIdx) || null,
      title: form.title,
      description: form.description,
      vacationSchedule: form.vacationSchedule.map(({ isSingle, isFirst, isLast, ...schedule }) => ({
        date: schedule.date,
        vacationDayType: schedule.vacationDayType,

        ...((schedule.vacationDayType === 'half') || (schedule.vacationDayType === 'quarter')) ? {
          startTime: `${schedule.date} ${(isSingle || isFirst) ? schedule.startTime : "00:00:00"}`,
          endTime: `${schedule.date} ${(isSingle || isLast) ? schedule.endTime : "23:59:59"}`,
        } : {}
      })),
      uploadFiles: form.uploadFiles,
      apprList: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };
  };

  const create = (form) => {
    return postVacations(getParams(form));
  };

  const validate = (form) => {
    let errors = {};
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };

};

export default getTask;